import $ from 'jquery';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';
import FB from '@shared/facebook-sdk';
import { tagsSessionId } from '@shared/threatmetrix';
import { getCSRFToken } from '@shared/cookie';

/*
 * FBLogin model
 */
export default Backbone.Model.extend({
  defaults: {
    first_name: '',
    profile_picture_url: '',
    email: '',
  },

  /**
   * We need to have a profile picture
   */
  isProfileData() {
    if (!this.get('profile_picture_url')) {
      return false;
    }
    if (!this.get('first_name')) {
      return false;
    }
    if (!this.get('email')) {
      return false;
    }
    return true;
  },

  getFBProfilePicture() {
    const self = this;
    FB.api('/me/picture?type=normal', response => {
      self.set({ profile_picture_url: response.data.url });
      self.trigger('change', self);
    });
  },

  getFBProfileData() {
    const self = this;
    FB.api('/me', response => {
      self.set({
        first_name: response.first_name,
        email: response.email,
      });
      self.trigger('change', self);
    });
  },

  checkLoginStatus() {
    const self = this;
    FB.getLoginStatus(
      response => {
        if (response.status == 'connected') {
          // The user is logged into Facebook and has authenticated
          // your application
          self.set({
            fbtoken: response.authResponse.accessToken,
            email: response.email,
          });
          self.trigger('fb:connected');
        } else {
          self.trigger('fb:notconnected');
        }
      },
      { scope: 'user_location,user_website,email,user_birthday' },
    );
  },

  doLogin() {
    const self = this;
    FB.login(
      response => {
        if (response.authResponse) {
          self.trigger('fb:connected');
        } else {
          self.trigger('fb:cancelled');
        }
      },
      { scope: 'user_location,user_website,email,user_birthday' },
    );
  },

  linkFbAccount() {
    const username = this.get('username');
    const password = this.get('password');
    const fbtoken = this.get('fbtoken');
    const profilePictureUrl = this.get('profile_picture_url');

    if (!username || !password) return;

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/users/facebook/onLink.php',
      context: this,
      data:
        `auto_link=1&decode=1&username=${username}` +
        `&passwd=${password}` +
        `&token=${fbtoken}` +
        `&importPic=${profilePictureUrl}`,

      success(result) {
        if (result.status == 'success') {
          this.trigger('fb:loginsuccess');
        } else if (/different Facebook/i.test(result.reason)) {
          if (result.url) {
            this.trigger('fb:redirection', result.url);
          } else {
            this.trigger('fb:loginsuccess');
          }
        } else if (/Invalid username or password/i.test(result.reason)) {
          if (result.url) {
            this.trigger('fb:loginerror', result.reason);
          } else {
            this.trigger('fb:loginsuccess');
          }
        } else {
          const msg = T_('Unknown error: ') + result.reason;
          this.trigger('fb:loginerror', msg);
        }
      },
      error() {
        const msg = T_("Error: can't connect to server");
        this.trigger('fb:loginerror', msg);
      },
    });
  },

  signupWithFb() {
    const username = this.get('username');
    const fbtoken = this.get('fbtoken');
    let isEmployer = '0';
    if (this.get('looking_for') == 'Employer') {
      isEmployer = '1';
    }
    const csrf_token = getCSRFToken();
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/users/facebook/onSignup.php',
      context: this,
      data:
        `decode=1&action=register&newusername=${username}` +
        `&currency=1&timezone=120&isEmployer=${isEmployer}` +
        `&token=${fbtoken}&page=${window.location.pathname}` +
        `&thm_session=${tagsSessionId}` +
        `&csrf_token=${csrf_token}`,
      success(result) {
        if (result.status == 'success') {
          this.trigger('fb:signupsuccess');
        } else if (result.reason) {
          this.trigger('fb:signuperror', result.reason);
        } else {
          const msg = T_('Unknown error');
          this.trigger('fb:signuperror', msg);
        }
      },
      error() {
        const msg = T_("Error: can't connect to server");
        this.trigger('fb:signuperror', msg);
      },
    });
  },
});
